import isNode from 'detect-node';

export default isNode;
